const routesPath = {
  LOGIN: "/",
  NOT_FOUND: "/not-found",
  DASHBOARD: "/dashboard",
  FORGOT_PASSWORD: "/forgot-password",
  SETTINGS: "/settings",
  NOTIFICATIONS: "/notifications",
  SUBMITTED_BIDS: "/submitted-bids",
  PURCHASE_ORDER: "/purchase-order",
  RESET_PASSWORD: "/vendor/reset-password",
};

export default routesPath;
